import {logger} from '../../logger';
import React, {useCallback, useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import {HeartIcon} from './icons';

// Restored from test #2 (q3_2026_product_page, src/product-ab/components/favorite-button.tsx before dda1ebecc) and drawn as the
// redesign's heart. The same store the home-page carousels use (_df_home_ab_below_fold.cshtml), so a product favorited here shows
// as favorited there and vice versa.
const FAVORITE_STORAGE_KEY = 'store_ab_below_fold_favorites_by_product_id';

function getFavorites(): string[] {
    try {
        const favorites = JSON.parse(localStorage.getItem(FAVORITE_STORAGE_KEY) || '[]');

        return Array.isArray(favorites) ? favorites : [];
    } catch {
        return [];
    }
}

function saveFavorites(favorites: string[]): void {
    try {
        localStorage.setItem(FAVORITE_STORAGE_KEY, JSON.stringify(favorites));
    } catch (err) {
        logger.error(err);
    }
}

const FavoriteButton: React.FC = observer(() => {
    const productId = s.prod && s.prod.ProductID > 0 ? String(s.prod.ProductID) : '';
    const [isFavorite, setIsFavorite] = useState(false);

    useEffect(() => {
        if (!productId) {
            return;
        }

        setIsFavorite(getFavorites().includes(productId));
    }, [productId]);

    const toggle = useCallback(() => {
        if (!productId) {
            return;
        }

        const favorites = getFavorites();
        const next = favorites.includes(productId) ? favorites.filter(id => id !== productId) : [...favorites, productId];

        saveFavorites(next);
        setIsFavorite(next.includes(productId));
    }, [productId]);

    if (!productId || !s.isRetail) {
        return null;
    }

    return (
        <button
            type="button"
            className={isFavorite ? 'pp3-heart selected' : 'pp3-heart'}
            aria-pressed={isFavorite}
            aria-label={isFavorite ? 'Remove from wish list' : 'Save to wish list'}
            onClick={toggle}
        >
            <HeartIcon filled={isFavorite} />
        </button>
    );
});

export default FavoriteButton;
